(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadCallDeleteController',LeadCallDeleteController);

    LeadCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadCall'];

    function LeadCallDeleteController($uibModalInstance, entity, LeadCall) {
        var vm = this;
        vm.leadCall = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
